// First touch (written once, kept 90 days) + last touch (replaced when new UTMs arrive), in localStorage.
const KEY = "vt_attr2";
const LEGACY_KEY = "vt_attr";
const TTL = 90 * 24 * 3600 * 1000;
const UTM = ["source", "medium", "campaign", "content", "term"];

const cleanUtm = (v) => String(v || "").toLowerCase().replace(/[^a-z0-9_-]/g, "").slice(0, 100);
const cleanHost = (v) => String(v || "").toLowerCase().replace(/^www\./, "").replace(/[^a-z0-9.-]/g, "").slice(0, 100);
const cleanPath = (v) => String(v || "").toLowerCase().replace(/[^a-z0-9/_.-]/g, "").slice(0, 100);

function fromLegacy(t) {
  if (!t) return null;
  let host = "";
  try { host = t.referrer ? new URL(t.referrer).hostname : ""; } catch { /* ignore */ }
  const utm = t.campaign || !["(direct)", "organic", "social", "referral"].includes(t.medium) ? t : {};
  return { source: cleanUtm(utm.source), medium: cleanUtm(utm.medium), campaign: cleanUtm(utm.campaign), content: cleanUtm(utm.content),
    term: cleanUtm(utm.term), referrer_host: cleanHost(host), landing_path: cleanPath(t.landing), ts: t.at };
}

function read() {
  try {
    let v = JSON.parse(localStorage.getItem(KEY) || "null");
    if (!v) {
      const old = JSON.parse(localStorage.getItem(LEGACY_KEY) || "{}");
      v = { first: fromLegacy(old.first), last: fromLegacy(old.last) };
    }
    const fresh = (t) => t && Date.now() - Date.parse(t.ts) < TTL;
    return { first: fresh(v.first) ? v.first : null, last: fresh(v.last) ? v.last : null };
  } catch { return { first: null, last: null }; }
}

function externalReferrerHost() {
  try {
    const h = document.referrer ? new URL(document.referrer).hostname : "";
    return h && h.replace(/^www\./, "") !== window.location.hostname.replace(/^www\./, "") ? cleanHost(h) : "";
  } catch { return ""; }
}

export function captureAttribution() {
  if (typeof window === "undefined") return;
  const q = new URLSearchParams(window.location.search);
  const cur = read();
  const base = { landing_path: cleanPath(window.location.pathname), ts: new Date().toISOString() };
  let t = null;
  if (q.get("utm_source")) {
    t = { ...base, referrer_host: externalReferrerHost() };
    UTM.forEach((k) => { const v = cleanUtm(q.get(`utm_${k}`)); if (v) t[k] = v; });
  } else if (!sessionStorage.getItem("vt_ref_seen")) {
    const host = externalReferrerHost();
    if (host) t = { ...base, referrer_host: host };
    else if (!cur.last) t = base;
  }
  try { sessionStorage.setItem("vt_ref_seen", "1"); } catch { /* ignore */ }
  if (!t) return;
  try { localStorage.setItem(KEY, JSON.stringify({ first: cur.first || t, last: t })); } catch { /* ignore */ }
}

export function sessionId() {
  try {
    let id = sessionStorage.getItem("vt_sid");
    if (!id) { id = randomHex(); sessionStorage.setItem("vt_sid", id); }
    return id;
  } catch { return null; }
}

function randomHex() {
  const b = new Uint8Array(16);
  crypto.getRandomValues(b);
  return Array.from(b, (x) => x.toString(16).padStart(2, "0")).join("");
}

export function attributionSnapshot() {
  const v = read();
  return { first_touch: v.first, last_touch: v.last, session_id: sessionId() };
}

export function markInternalDevice() {
  try { localStorage.setItem("vt_internal", "1"); } catch { /* ignore */ }
}

// Random per-browser ID so a purchase event can only be claimed by the browser that started checkout.
export function browserId() {
  try {
    let id = localStorage.getItem("vt_bid");
    if (!id) { id = randomHex(); localStorage.setItem("vt_bid", id); }
    return id;
  } catch { return null; }
}

export function attributionHeader() {
  let internal = false;
  try { internal = localStorage.getItem("vt_internal") === "1"; } catch { /* ignore */ }
  const bid = browserId();
  return encodeURIComponent(JSON.stringify({ ...attributionSnapshot(), ...(internal ? { internal: true } : {}), ...(bid ? { bid } : {}) }));
}

export function sendLanding(api) {
  try {
    if (sessionStorage.getItem("vt_landing_sent")) return;
    sessionStorage.setItem("vt_landing_sent", "1");
  } catch { return; }
  api.post("/events/landing", { attribution: attributionSnapshot() }).catch(() => {});
}

export function trackProductView(api, productId) {
  if (productId) api.post("/events/product-view", { product_id: productId, attribution: attributionSnapshot() }).catch(() => {});
}
